import { ISingleIdParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class ResumeSubscriptionRequest extends Request<ISingleIdParams, IEmptyResult> {
  constructor(id: string) {
    super('resumeSubscription', {
      id: id
    });
  }
}

